import React from 'react'

import { InvestmentEntitySelectionBlocker } from '@cash-web/protos/squareup/franklin/blockers/investment_entity_selection_blocker.pb'
import { ResponseContext } from '@cash-web/protos/squareup/franklin/ResponseContextProto.pb'
import { useMutationSubmitInvestmentEntitySelection } from '@cash-web/shared-data-access-api/react-query'

import { BlockerProps } from '../..'
import { InvestmentEntitySelection } from './InvestmentEntitySelection'

interface Props extends BlockerProps {
  blocker: InvestmentEntitySelectionBlocker
}

export function RoundUpInvestmentEntitySelection({ blocker }: Props): React.ReactElement {
  const { mutateAsync: mutateSubmitInvestmentEntity } = useMutationSubmitInvestmentEntitySelection()

  return (
    <InvestmentEntitySelection
      blocker={blocker}
      submitInvestment={function (entity: string): Promise<{ response_context?: ResponseContext }> {
        return mutateSubmitInvestmentEntity({ investment_entity_token: entity })
      }}
      submitMultipleInvestments={function (entities: Array<string>): Promise<{ response_context?: ResponseContext }> {
        throw new Error('Multiple investements not implemented for roundup entity selection')
      }}
    />
  )
}
